import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';
import { Api } from 'src/app/shared/constants/api';
import { DataService } from 'src/app/shared/services/data.service';
import { NGXLogger } from 'ngx-logger';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { MatDialog } from '@angular/material/dialog';
import { debounceTime, delay, map, takeUntil, tap } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { ICharge, IChargeCriteria } from '../../charge/charge.interface';
import * as _ from 'underscore';
import { ConfirmDailogueComponent } from 'src/app/shared/components/dailogue/confirm-dailogue.component';
import { Message } from 'src/app/shared/constants/message';
import { KEYS } from 'src/app/shared/constants/keys';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';


@Component({
    selector: 'app-map-income-to-business-segment-form',
    templateUrl: './map-income-to-business-segment-form.component.html',
    styleUrls: ['./map-income-to-business-segment-form.component.less'],
    standalone: false
})
export class MapIncomeToBusinessSegmentFormComponent implements OnInit {
  editPermission: boolean;
  addPermission: boolean;

  constructor(private formBuilder: FormBuilder, private service: DataService,
    private logger: NGXLogger, private permissionService: PermissionService,
    private utilityService: UtilityService,
    private dailog: MatDialog, private changerDetectorRef: ChangeDetectorRef) { }

  MapIncomeToBusinessSegmentForm: FormGroup;

  data: any;
  isEditedData: boolean;
  originalChargeDetails: any[] = [];

  filteredSegments: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  segments: any;
  segmentSearchCtrl = new FormControl('');
  searching: boolean = false;

  chargeCriteria: IChargeCriteria = {}
  charges: any[] = [];
  filteredCharges: any[] = [];
  chargeCodeSearchCtrl = new FormControl('');

  onDestroy = new Subject<void>();
  chargeDetailsDataSource = new MatTableDataSource<AbstractControl>([]);

  // displayedColumns = [
  //   'chargeCode', 'chargeName','chargeCategory','unitType',
  //   'sacCode', 'sacName', 'sGST', 'cGST', 'iGST', 'gstFrom','gstUpto', 'centralCess','stateCess',
  //   'deactivate', 'action'
  // ];

  displayedColumns = ['chargeCode', 'chargeName', 'chargeCategory', 'action'];


  ngOnInit(): void {
    this.initializeForm();
    this.getAllPermission();
    this.filterSegments();
    this.getSegments();
    this.getCharges();
    this.segmentId.valueChanges.subscribe(segmentId => {
      if (segmentId) {
        this.checkExistingchargesBySegment(segmentId);
      } else {
        this.clearChargeDetails();
      }
    });
  }

  private initializeForm(): void {
    this.MapIncomeToBusinessSegmentForm = this.formBuilder.group({
      id: [],
      segmentId: [null, Validators.required],
      chargeDetails: this.formBuilder.array([])
    });
    this.chargeDetails.push(this.createEmptyRow());
    // Bind table to FormArray
    this.chargeDetailsDataSource.data = this.chargeDetails.controls;
  }

  checkExistingchargesBySegment(segmentId: number): void {
    this.service.get(`${Api.MAP_INCOME_TO_BUSINESS_SEGMENT}/${segmentId}`)
    .subscribe({
        next: (res: any) => {
          this.logger.info('Fetched saved Charge Details', res);
          if (!res) {
            this.clearChargeDetails();
            this.utilityService.toastrInfoMessage(
              'No Mapping Available for Segment, Please create new Mappings.'
            );
            return;
          }

          this.MapIncomeToBusinessSegmentForm.get('id').setValue(res.id);

          // adding available Charge details to the table
          if (res.chargeDetails?.length > 0) {
            this.patchChargeDetails(res.chargeDetails);
            this.MapIncomeToBusinessSegmentForm.markAsPristine();
          } else {
            this.clearChargeDetails();
            this.utilityService.toastrInfoMessage(
              'No Charge Details found, You can add new mappings.'
            );
          }
        },
        error: () => {
          this.clearChargeDetails();
        }
      });
  }

  patchChargeDetails(chargeDetails: any[]): void {
    this.originalChargeDetails = chargeDetails.map(cd => ({ ...cd }));
    this.chargeDetails.clear();

    chargeDetails.forEach(cd => {
      const formGroup = this.formBuilder.group({
        id: [cd.id || null],
        chargeId: [cd.chargeId, Validators.required],
        chargeName: [{ value: null }],
        chargeCategory: [{ value: null }]
      });

      this.chargeDetails.push(formGroup);
      this.populateChargeDetailsFromMaster(formGroup);
    });

    this.chargeDetailsDataSource.data = this.chargeDetails.controls;
  }

  populateChargeDetailsFromMaster(row: AbstractControl): void {
    const chargeId = row.get('chargeId')?.value;
    const charge = this.charges.find(c => c.parentId === chargeId);

    row.get('chargeName')?.setValue(charge?.name || null);
    row.get('chargeCategory')?.setValue(charge?.chargeCategory || null);
  }

  clearChargeDetails(): void {
    this.originalChargeDetails = [];
    this.chargeDetails.clear();
    this.MapIncomeToBusinessSegmentForm.get('id').setValue(null);

    this.chargeDetails.push(this.createEmptyRow());
    this.chargeDetailsDataSource.data = this.chargeDetails.controls;
  }

  getSegments() {
    let companyId = +localStorage.getItem(KEYS.COMPANY_ID);
    if (companyId) {
      this.service.get(Api.COMPANY_BUSINESS_SEGMENT_DD + '/' + companyId).forEach(res => {
        if (res) {
          this.segments = res.filter(r => r.businessSegmentName === 'LCL Export' || r.businessSegmentName === 'Headload Export');
          this.filteredSegments.next(this.segments);
        }
      });
    }
  }

  filterSegments() {
    this.segmentSearchCtrl.valueChanges.pipe(
      tap(() => this.searching = true),
      debounceTime(350),
      takeUntil(this.onDestroy),
      map(search => {
        if (!this.segments?.length) { return []; }

        const searchSegment = (search || '').toLowerCase();

        if (!searchSegment) { return this.segments; }

        return this.segments.filter(segment =>
          segment.businessSegmentName?.toLowerCase().includes(searchSegment)
        );
      })
    )
      .subscribe({
        next: filtered => {
          this.searching = false;
          this.filteredSegments.next(filtered);
        },
        error: () => { this.searching = false; }
      });
  }

  getCharges() {
    this.chargeCriteria['active.equals'] = true;
    this.service.get(Api.CHARGE_FOR_DD, this.chargeCriteria).subscribe(res => {
      if (res) {
        this.logger.info("Checking Charges Res", res);
        this.charges = res;
        this.filteredCharges = [...this.charges];
        this.filterChargeCodes();
      }
    })
  }

  filterChargeCodes() {
    this.logger.info("Charge Code is Searched value->", this.chargeCodeSearchCtrl.value);
    this.chargeCodeSearchCtrl.valueChanges.pipe(
      debounceTime(300)).subscribe(search => {
        const value = (search || '').toLowerCase();

        this.filteredCharges = this.charges.filter(c =>
          c.code?.toLowerCase().includes(value) ||
          c.name?.toLowerCase().includes(value)
        );
      });
  }

  chargedChanged(index: number) {
    const row = this.chargeDetails.at(index);
    const selectedChargeId = row.get('chargeId')?.value;

    const charge = this.charges.find(c => c.parentId === selectedChargeId);
    row.get('chargeName')?.setValue(charge?.name || null);
    row.get('chargeCategory')?.setValue(charge?.chargeCategory || null);
    // row.get('unitType')?.setValue(charge?.unitType || null);
  }

  checkChargeDisableCondition(c: any) {
    return (_.findWhere(this.chargeDetails.value, { chargeId: c.parentId })) || (c.status != 'APPROVED') ? true : false;
  }

  createEmptyRow(): FormGroup {
    return this.formBuilder.group({
      id: [null],
      chargeId: [null, Validators.required],
      chargeName: [null, Validators.required],
      chargeCategory: [null, Validators.required],
      // unitType: [{ value: null, disabled: true }, Validators.required]
    });
  }

  addRow() {
    this.chargeDetails.push(this.createEmptyRow());
    this.chargeDetailsDataSource.data = this.chargeDetails.controls;
  }

  deleteRow(index: number) {
    if (this.chargeDetails.length === 1) {
      return;
    }
    const dailogRef = this.dailog.open(ConfirmDailogueComponent, {
      data: Message.DELETE_OPEN_DAILOG,
      maxWidth: "300px",
      maxHeight: "150px"
    });
    dailogRef.afterClosed().subscribe(dailogResult => {
      if (dailogResult === false) {
        return;
      }
      this.chargeDetails.removeAt(index);
      this.chargeDetailsDataSource.data = this.chargeDetails.controls;
      this.chargeDetails.markAsDirty();
      this.MapIncomeToBusinessSegmentForm.markAsDirty();
    });
  }

  private buildPayload() {
    const formValue = this.MapIncomeToBusinessSegmentForm.value;

    const chargeDetails = this.chargeDetails.controls.map(c => ({
      id: c.get('id')?.value ?? null,   // for update
      chargeId: c.get('chargeId')?.value,
      chargeName: c.get('chargeName')?.value,
      chargeCategory: c.get('chargeCategory')?.value,
      isDeleted: false
    }));

    return {
      id: this.id?.value ?? null,
      segmentId: formValue.segmentId,
      chargeDetails
    };
  }


  onSave() {
    this.MapIncomeToBusinessSegmentForm.markAllAsTouched();
    if (this.MapIncomeToBusinessSegmentForm.invalid) {
      return;
    }
    if (!this.MapIncomeToBusinessSegmentForm.dirty) {
      this.utilityService.toastrWarningMessage('No changes to save');
      return;
    }
    this.data = this.buildPayload();
    this.isEditedData = true;
    console.log('Payload backend:', this.data);
    if (this.id?.value) {
      this.openDailog(Message.SAVE_OPEN_DAILOG_IN_EDIT);
    } else {
      this.openDailog(Message.SAVE_OPEN_DAILOG);
    }
  }

  openDailog(message?: string) {
    const dailogRef = this.dailog.open(ConfirmDailogueComponent, {
      data: message,
      maxWidth: "300px",
      maxHeight: "150px"
    });

    dailogRef.afterClosed().subscribe(dailogResult => {
      this.logger.info('result', dailogResult);
      if (dailogResult === false) {
        return;
      }
      else {
        if (!this.isEditedData) {
          this.logger.info('result after true edi', this.isEditedData);
        }
        else {
          this.logger.info('result after true', this.isEditedData);
          this.saveMapIncomeToBusinessSegment();
        }
      }
    })
  }

  private saveMapIncomeToBusinessSegment() {
    let method = (this.id.value) ? 'put' : 'post';
    let message = (this.id.value) ? 'updated' : 'saved';
    this.service[method](Api.MAP_INCOME_TO_BUSINESS_SEGMENT, this.data).subscribe(res => {
      if (res) {
        this.logger.info('Map Charge to Business Segment Save Res', res);

        this.MapIncomeToBusinessSegmentForm.get('id').setValue(res.id);
        this.originalChargeDetails = this.chargeDetails.controls.map(c => ({
          id: c.get('id')?.value ?? null,
          chargeId: c.get('chargeId')?.value,
          chargeName: c.get('chargeName')?.value,
          chargeCategory: c.get('chargeCategory')?.value
        }));
        this.MapIncomeToBusinessSegmentForm.markAsPristine();
        this.utilityService.notifier(`Map Charge to Business Segment ${message} Successfully`, 'success');
      }
    });
  }

  onRevert() {
  }


  onCancel() {
    if (!this.MapIncomeToBusinessSegmentForm.dirty) {
      this.utilityService.toastrInfoMessage('There are no changes to cancel.');
      return;
    }
    const message = this.id?.value ? Message.CANCEL_OPEN_DAILOG_IN_EDIT : Message.CANCEL_OPEN_DAILOG;
    const dailogRef = this.dailog.open(ConfirmDailogueComponent, {
      data: message,
      maxWidth: "300px",
      maxHeight: "150px"
    });
    dailogRef.afterClosed().subscribe(dailogResult => {
      if (dailogResult === false) {
        return;
      }
      this.revertChargeDetails();
    });
  }

  private revertChargeDetails() {
    this.chargeDetails.clear();
    if (this.originalChargeDetails.length > 0) {
      this.originalChargeDetails.forEach(cd => {
        const formGroup = this.formBuilder.group({
          id: [cd.id || null],
          chargeId: [cd.chargeId, Validators.required],
          chargeName: [{ value: null }],
          chargeCategory: [{ value: null }]
        });
        this.chargeDetails.push(formGroup);
        this.populateChargeDetailsFromMaster(formGroup);
      });
    } else {
      this.chargeDetails.push(this.createEmptyRow());
    }
    this.chargeDetailsDataSource.data = this.chargeDetails.controls;
    this.MapIncomeToBusinessSegmentForm.markAsPristine();
    this.MapIncomeToBusinessSegmentForm.markAsUntouched();
    this.data = null;
    this.isEditedData = false;
  }

  public getAllPermission(){
      let permissionCodes=[PermissionKey.MAP_INCOME_TO_BUSINESS_SEGMENT_ADD,PermissionKey.MAP_INCOME_TO_BUSINESS_SEGMENT_EDIT];
      let permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.MAP_INCOME_TO_BUSINESS_SEGMENT);
      this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.MAP_INCOME_TO_BUSINESS_SEGMENT_EDIT})?.show?true:false;
      this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.MAP_INCOME_TO_BUSINESS_SEGMENT_ADD})?.show?true:false;
      this.logger.info("Add permission value",this.addPermission);
      this.logger.info("Edit permission value",this.editPermission);
    }

  get id() { return this.MapIncomeToBusinessSegmentForm.get('id'); }
  get segmentId() { return this.MapIncomeToBusinessSegmentForm.get('segmentId'); }
  get chargeDetails(): FormArray {
    return this.MapIncomeToBusinessSegmentForm.get('chargeDetails') as FormArray;
  }

}